export default {
  disasterAvoidPolygons: {
    name: 'Nome',
    description: 'Descrição',
    disasterType: 'Tipo de desastre',
    disasterSubType: 'Subtipo de desastre',
    fillRequiredFields: 'Por favor preencha os campos obrigatórios para a área de desastre',
    avoidAreaSaved: 'Área de desastre salva',
    avoidAreaDeleted: 'Área de desastre excluída',
    fillAreaProperties: 'Preencha os dados da área de desastre e a salve',
    editProperties: 'Alterar propriedades',
    createADisasterPolygon: 'Criar polígono de desastre',
    createADisasterRectangle: 'Criar retângulo de desastre',
    errorWhileTryingToSaveDisasterArea: 'Erro ao tentar salvar áre de desastre',
    authorizationError: 'Erro de autorização. Por favor, certifique-se de que a chave que você digitou é válida. Para reentrar na chave, recarregue a página',
    disasterAreaUsageInfo: 'Você pode: mover o map para carregar áreas de desastre de uma região desejada, usar a ferramenta de desenho de polígonos para criar novas áreas de desastre e clique em uma área para editá-la',
    errorCodes: {
      2404: 'Provedor não existente',
      3404: 'Tipo de áre de desastre inválida',
      5409: 'Nome de área de desastre já em uso'
    },
    statuses: {
      401: 'Não autorizado',
    }
  }
}
